import { ColumnConfig } from '../hooks/useTablePreferences';

export const wellnessItemColumns: ColumnConfig[] = [
  { key: 'name', label: 'Name', defaultWidth: 220, minWidth: 150, visible: true, sortable: true, resizable: true, draggable: true },
  { key: 'type', label: 'Type', defaultWidth: 110, minWidth: 90, visible: true, sortable: true, resizable: true, draggable: true },
  { key: 'createdAt', label: 'Created', defaultWidth: 130, minWidth: 100, visible: true, sortable: true, resizable: true, draggable: true },
];
